export class AppValueModel {
	public category: string;
	public code: string;
	public descriptionEn: string;
	public descriptionId: string;
	public oderNo: number;
	public param1: string;
	public param2: string;
	public subCategory: string;

	public convert(dto: any): AppValueModel {
		if (dto.category) {
			this.category = dto.category;
		}
		if (dto.code) {
			this.code = dto.code;
		}
		if (dto.descriptionEN) {
			this.descriptionEn = dto.descriptionEN;
		}
		if (dto.descriptionID) {
			this.descriptionId = dto.descriptionID;
		}
		if (dto.oderNo) {
			this.oderNo = dto.oderNo;
		}
		if (dto.param1) {
			this.param1 = dto.param1;
		}
		if (dto.param2) {
			this.param2 = dto.param2;
		}
		if (dto.subCategory) {
			this.subCategory = dto.subCategory;
		}

		return this;
	}
}
